var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnPath(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.5,
    fill: "white",
    stroke: "#EEEFF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6895 16.8276L19.1812 9.31928C18.5562 8.69428 17.4562 8.68594 16.8229 9.31928L9.32287 16.8193C8.67287 17.4693 8.67287 18.5193 9.32287 19.1693L16.8229 26.6693C17.1479 26.9943 17.5729 27.1526 17.9979 27.1526C18.4229 27.1526 18.8479 26.9943 19.1729 26.6693L26.6645 19.1776C27.3229 18.5443 27.3312 17.4943 26.6895 16.8276ZM18.0062 25.4943L10.5062 17.9943L18.0062 10.4943L25.5062 17.9943L18.0062 25.4943ZM14.6645 17.1693V20.5026H16.3312V18.0026H19.6645V20.0859L22.5812 17.1693L19.6645 14.2526V16.3359H15.4979C15.0395 16.3359 14.6645 16.7109 14.6645 17.1693Z",
    fill: "#477AE9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnPath);
export default __webpack_public_path__ + "static/media/btnPath.38c7d26841072add012b5e99e441f0a5.svg";
export { ForwardRef as ReactComponent };